import entries from "@Object/entries";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {
    passengerClassGroupsBackgroundColoring
} from "@CheckOrder/features/classPicker/constants/passengerClassGroupsBackgroundColoring";
import {useMemo} from "react";

export default function useGetPassengerClassColor(passengerId: number, isReturn: boolean) {
    const {
        singleSelectedPassengerClasses,
        returnSelectedPassengerClasses,
    } = useAppSelector((state) => (state.checkOrder.ticket))

    const selectedPassengerClasses = isReturn ? returnSelectedPassengerClasses : singleSelectedPassengerClasses

    const arrayOfAllPassengerGroups: number[][] = useMemo(() => {
        const arrayOfPassengerGroups = []
        entries(selectedPassengerClasses.classToPassengersMap).forEach(([_passengerClassId, passengersGroups]) => {
            if (selectedPassengerClasses.passengerToPassengerClassMap[passengersGroups[0][0]].groupId) {
                arrayOfPassengerGroups.push(passengersGroups)
            }
        })

        return arrayOfPassengerGroups.flat(1)
    }, [selectedPassengerClasses.classToPassengersMap])

    const indexOfGroupWithPassenger = arrayOfAllPassengerGroups.findIndex((passengerIds) => (
        passengerIds.includes(passengerId)
    ))

    let color: string

    if (indexOfGroupWithPassenger !== -1) {
        color = passengerClassGroupsBackgroundColoring[indexOfGroupWithPassenger % passengerClassGroupsBackgroundColoring.length]
    }

    return {
        color,
    }
}